
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30123',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30123",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54297",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7925",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11372",
  "I18n": "static-7.1604",
  "quartz": "static-1.6887",
  "quartz-config": "static-1.665",
  "quartz-core": "static-1.6106",
  "react-dlb": "static-1.77",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.771",
  "enviro": "static-4.428",
  "feedback-shared-ui": "static-1.54284",
  "feedback-utils": "static-1.54288",
  "forms-embed-utils-lib": "static-1.4374",
  "forms-utils-lib": "static-1.12416",
  "foundations-assets": "static-1.4764",
  "foundations-components": "static-1.7759",
  "foundations-theming": "static-1.4327",
  "hub-http": "static-1.6132",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11680",
  "icons": "static-2.639",
  "immutable": "static-2.77",
  "quick-fetch": "static-1.3845",
  "raven": "static-3.5829",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16570",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5275",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.485",
  "tinymce-plugins": "static-1.57230",
  "transmute": "static-2.85",
  "ui-images": "static-2.1131",
  "UIComponents": "static-3.8319",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9542",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3334",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3164",
  "quartz-webpack": "static-1.3111",
  "foundations-theming-specialty": "static-1.2043",
  "property-description-translator": "static-1.3764",
  "HeadJS": "static-2.736",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3036",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4236",
  "jasmine-runner": "static-1.6380",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.820",
  "hubspotter-http": "static-1.4581",
  "mobile-manifest-mixins": "static-1.509",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.562",
  "quartz-head": "static-1.552",
  "quartz-i18n": "static-1.562",
  "quartz-routing": "static-1.317",
  "quartz-test": "static-1.562",
  "quartz-tracking": "static-1.266",
  "ui-fonts": "static-1.634",
  "usage-tracker-container": "static-1.7238",
  "usage-tracker-core": "static-1.7098",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7163",
  "reference-resolvers": "static-1.8080",
  "sanitize-text": "static-1.8057",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10286",
  "sanitize": "static-1.4385",
  "outpost": "static-1.4105",
  "rpc-client-utils": "static-1.4557",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4028",
  "floating-ui": "static-1.54",
  "hs-story-utils": "static-1.9342",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1569",
  "bend-plugin-foundations-theming": "static-1.2810",
  "foundations-theming-base": "static-1.3312",
  "stylex": "static-1.30",
  "hs-locale-management": "static-1.17",
  "csstype": "static-1.50",
  "ai-components-ui-library": "static-1.8722",
  "atom": "static-1.4983",
  "codemirror": "static-5.93",
  "content-assistance-lib": "static-1.7623",
  "ContentUtils": "static-1.68088",
  "data-token-picker": "static-1.16251",
  "file-manager-components": "static-1.23347",
  "FileManagerCore": "static-1.38846",
  "FileManagerLib": "static-1.38987",
  "frontend-preferences-client": "static-1.7837",
  "hub-http-contrib": "static-1.2955",
  "interframe": "static-3.4675",
  "layout-dnd-components": "static-1.12275",
  "layout-dnd-utils": "static-1.11250",
  "property-translator": "static-1.5319",
  "react-codemirror": "static-1.10536",
  "react-colorpicker": "static-2.10122",
  "reference-resolvers-lite": "static-1.8003",
  "rich-text-lib": "static-1.19680",
  "tinymce-data": "static-1.40201",
  "tinymce-themes": "static-1.56086",
  "ui-addon-emoji-picker": "static-1.9799",
  "ui-addon-sales-email": "static-1.5124",
  "ui-brand-identity-lib": "static-1.14858",
  "bender-build-tools": "static-1.3063",
  "hub-http-shared-msw-handlers": "static-1.9765",
  "hubspotter-http-shared-msw-handlers": "static-1.9763",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4934",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "chirp-fetch": "static-1.1794",
  "chatspot-core": "static-1.20892",
  "copilot-toolkit": "static-1.10887",
  "data-fetching-client": "static-1.9587",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4681",
  "ui-addon-video-player": "static-1.8609",
  "ui-coaching-tips": "static-1.28297",
  "usage-tracker": "static-1.7248",
  "cms-field-types": "static-1.4722",
  "content-icons-ui": "static-1.2204",
  "integrations-lib": "static-1.15836",
  "customer-data-objects": "static-1.7572",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4563",
  "apollo-stack-hubspot": "static-3.84",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "immerable": "static-1.4065",
  "ui-addon-iframeable": "static-1.8963",
  "video-components-external": "static-1.10993",
  "video-data-lib": "static-1.34651",
  "audio-components": "static-1.5785",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29137",
  "FileManagerImages": "static-1.36498",
  "foundations-components-legacy": "static-1.784",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.523",
  "ui-universal-auth": "static-1.8863",
  "urlinator": "static-1.4444",
  "video-components": "static-1.12996",
  "video-embed": "static-1.35485",
  "ts-schema": "static-1.4007",
  "ContentData": "static-1.68163",
  "layout-data-lib": "static-1.9575",
  "react-dnd-compat": "static-1.4531",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1465",
  "external-options-client-types": "static-1.4087",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6787",
  "hs-promise-utils": "static-1.5507",
  "inbound-db-properties-service-client": "static-1.3773",
  "NamespacedHubStyle": "static-2.8995",
  "growth-onboarding-confetti": "static-1.2983",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11061",
  "amplitude-session-replay-browser": "static-1.58",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5507",
  "magpie-types": "static-1.4967",
  "simple-logging-lib": "static-1.2964",
  "growth-onboarding-feedback-components": "static-1.6494",
  "flux-actions": "static-1.325",
  "hubspot-apollo-client": "static-1.4790",
  "integrations-error-boundary-lib": "static-1.13251",
  "integrations-tracking-lib": "static-1.5509",
  "laboratory-lib": "static-3.7071",
  "native-integrations-shared-strings": "static-1.7698",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10060",
  "unified-auth": "static-1.377",
  "navigation-messaging": "static-1.7034",
  "content-media-composition-data-lib": "static-1.11980",
  "content-media-compositions": "static-2.15987",
  "idb-keyval": "static-1.42",
  "media-bridge-lib": "static-1.18772",
  "unified-auth-core-lib": "static-1.658",
  "social-insights-client-types": "static-1.21839",
  "advanced-menus-core": "static-1.14994",
  "advanced-menus-lib": "static-1.11951",
  "ExportDialog": "static-6.10302",
  "ui-memberships-settings-lib": "static-1.33801",
  "conditional-properties-service-client": "static-1.3726",
  "crm-pipelines-api-client-types": "static-1.4071",
  "framework-builder-read-service-client": "static-1.3938",
  "framework-data-schema-quick-fetch": "static-1.6692",
  "inbound-db-meta-service-client": "static-1.3519",
  "multi-currency-client-types": "static-1.3620",
  "persist-promise": "static-1.3622",
  "foundations-components-test-utils": "static-1.5242",
  "reactive-lib": "static-1.636",
  "hubspot-apollo-cache": "static-1.249",
  "universal-page-editor-lib": "static-1.2921",
  "microsoft-drive-integration-lib": "static-1.68",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3647",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14993",
  "simple-menus-lib": "static-1.16510",
  "crm-record-cards-service-types": "static-1.3539",
  "location-customization-utils-lib": "static-1.8974",
  "react-flip-move": "static-1.68"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30123",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54297",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7925",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11372",
  "I18n": "/I18n/static-7.1604",
  "quartz": "/quartz/static-1.6887",
  "quartz-config": "/quartz-config/static-1.665",
  "quartz-core": "/quartz-core/static-1.6106",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.771",
  "enviro": "/enviro/static-4.428",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54284",
  "feedback-utils": "/feedback-utils/static-1.54288",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4374",
  "forms-utils-lib": "/forms-utils-lib/static-1.12416",
  "foundations-assets": "/foundations-assets/static-1.4764",
  "foundations-components": "/foundations-components/static-1.7759",
  "foundations-theming": "/foundations-theming/static-1.4327",
  "hub-http": "/hub-http/static-1.6132",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11680",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.77",
  "quick-fetch": "/quick-fetch/static-1.3845",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16570",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5275",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tinymce-plugins": "/tinymce-plugins/static-1.57230",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1131",
  "UIComponents": "/UIComponents/static-3.8319",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9542",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3334",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3164",
  "quartz-webpack": "/quartz-webpack/static-1.3111",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2043",
  "property-description-translator": "/property-description-translator/static-1.3764",
  "HeadJS": "/HeadJS/static-2.736",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3036",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4236",
  "jasmine-runner": "/jasmine-runner/static-1.6380",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.820",
  "hubspotter-http": "/hubspotter-http/static-1.4581",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.509",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.562",
  "quartz-head": "/quartz-head/static-1.552",
  "quartz-i18n": "/quartz-i18n/static-1.562",
  "quartz-routing": "/quartz-routing/static-1.317",
  "quartz-test": "/quartz-test/static-1.562",
  "quartz-tracking": "/quartz-tracking/static-1.266",
  "ui-fonts": "/ui-fonts/static-1.634",
  "usage-tracker-container": "/usage-tracker-container/static-1.7238",
  "usage-tracker-core": "/usage-tracker-core/static-1.7098",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7163",
  "reference-resolvers": "/reference-resolvers/static-1.8080",
  "sanitize-text": "/sanitize-text/static-1.8057",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10286",
  "sanitize": "/sanitize/static-1.4385",
  "outpost": "/outpost/static-1.4105",
  "rpc-client-utils": "/rpc-client-utils/static-1.4557",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4028",
  "floating-ui": "/floating-ui/static-1.54",
  "hs-story-utils": "/hs-story-utils/static-1.9342",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1569",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2810",
  "foundations-theming-base": "/foundations-theming-base/static-1.3312",
  "stylex": "/stylex/static-1.30",
  "hs-locale-management": "/hs-locale-management/static-1.17",
  "csstype": "/csstype/static-1.50",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8722",
  "atom": "/atom/static-1.4983",
  "codemirror": "/codemirror/static-5.93",
  "content-assistance-lib": "/content-assistance-lib/static-1.7623",
  "ContentUtils": "/ContentUtils/static-1.68088",
  "data-token-picker": "/data-token-picker/static-1.16251",
  "file-manager-components": "/file-manager-components/static-1.23347",
  "FileManagerCore": "/FileManagerCore/static-1.38846",
  "FileManagerLib": "/FileManagerLib/static-1.38987",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7837",
  "hub-http-contrib": "/hub-http-contrib/static-1.2955",
  "interframe": "/interframe/static-3.4675",
  "layout-dnd-components": "/layout-dnd-components/static-1.12275",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11250",
  "property-translator": "/property-translator/static-1.5319",
  "react-codemirror": "/react-codemirror/static-1.10536",
  "react-colorpicker": "/react-colorpicker/static-2.10122",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8003",
  "rich-text-lib": "/rich-text-lib/static-1.19680",
  "tinymce-data": "/tinymce-data/static-1.40201",
  "tinymce-themes": "/tinymce-themes/static-1.56086",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9799",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5124",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14858",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9765",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9763",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4934",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "chirp-fetch": "/chirp-fetch/static-1.1794",
  "chatspot-core": "/chatspot-core/static-1.20892",
  "copilot-toolkit": "/copilot-toolkit/static-1.10887",
  "data-fetching-client": "/data-fetching-client/static-1.9587",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4681",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8609",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28297",
  "usage-tracker": "/usage-tracker/static-1.7248",
  "cms-field-types": "/cms-field-types/static-1.4722",
  "content-icons-ui": "/content-icons-ui/static-1.2204",
  "integrations-lib": "/integrations-lib/static-1.15836",
  "customer-data-objects": "/customer-data-objects/static-1.7572",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4563",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4065",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8963",
  "video-components-external": "/video-components-external/static-1.10993",
  "video-data-lib": "/video-data-lib/static-1.34651",
  "audio-components": "/audio-components/static-1.5785",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29137",
  "FileManagerImages": "/FileManagerImages/static-1.36498",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.784",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.523",
  "ui-universal-auth": "/ui-universal-auth/static-1.8863",
  "urlinator": "/urlinator/static-1.4444",
  "video-components": "/video-components/static-1.12996",
  "video-embed": "/video-embed/static-1.35485",
  "ts-schema": "/ts-schema/static-1.4007",
  "ContentData": "/ContentData/static-1.68163",
  "layout-data-lib": "/layout-data-lib/static-1.9575",
  "react-dnd-compat": "/react-dnd-compat/static-1.4531",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1465",
  "external-options-client-types": "/external-options-client-types/static-1.4087",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6787",
  "hs-promise-utils": "/hs-promise-utils/static-1.5507",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3773",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8995",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2983",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11061",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5507",
  "magpie-types": "/magpie-types/static-1.4967",
  "simple-logging-lib": "/simple-logging-lib/static-1.2964",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6494",
  "flux-actions": "/flux-actions/static-1.325",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4790",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13251",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5509",
  "laboratory-lib": "/laboratory-lib/static-3.7071",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7698",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10060",
  "unified-auth": "/unified-auth/static-1.377",
  "navigation-messaging": "/navigation-messaging/static-1.7034",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11980",
  "content-media-compositions": "/content-media-compositions/static-2.15987",
  "idb-keyval": "/idb-keyval/static-1.42",
  "media-bridge-lib": "/media-bridge-lib/static-1.18772",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.658",
  "social-insights-client-types": "/social-insights-client-types/static-1.21839",
  "advanced-menus-core": "/advanced-menus-core/static-1.14994",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11951",
  "ExportDialog": "/ExportDialog/static-6.10302",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33801",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3726",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4071",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3938",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6692",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3519",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3620",
  "persist-promise": "/persist-promise/static-1.3622",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5242",
  "reactive-lib": "/reactive-lib/static-1.636",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.249",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2921",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.68",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3647",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14993",
  "simple-menus-lib": "/simple-menus-lib/static-1.16510",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3539",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8974",
  "react-flip-move": "/react-flip-move/static-1.68"
}
};
